import { LEAD_COLORS, LEAD_LABELS, LeadStatusNameDashboard } from '@constants';
import { LeadChartData } from '@interfaces';

export const DASHBOARD_MAP_OPTIONS = {
  center: { lat: -12.046374, lng: -77.042793 },
  zoom: 11,
  disableDefaultUI: true,
  zoomControl: true,
};

export const MAP_ID = 'c56bf6988e91a407c78ecaa5';

export const DASHBOARD_LEGENDS = Object.values(LeadStatusNameDashboard).map(
  status => ({
    label: LEAD_LABELS[status],
    color: LEAD_COLORS[status],
    name: status,
  }),
);

export const filterDashboardMapData = (
  mapData: LeadChartData[],
): LeadChartData[] => {
  const allowedStatuses = [
    LeadStatusNameDashboard.PAID,
    LeadStatusNameDashboard.QUOTED,
    LeadStatusNameDashboard.PROCESSING,
  ];

  return mapData.filter(lead => allowedStatuses.includes(lead.type));
};
